import {
  AndroidHaptics,
  impactAsync,
  ImpactFeedbackStyle,
  performAndroidHapticsAsync,
  selectionAsync,
} from "@-/com.npmjs.expo-haptics";
import { Platform } from "@-/com.npmjs.react-native";
import type { PrimaryNavigationCustomizationFeedback } from "#primary-navigation-customization-drag";

/** Haptics are a nicety: an unavailable engine (web, tests, an old device) is never an error. */
function ignoreFailure(promise: Promise<void>): void {
  promise.catch(() => {});
}

/** Pickup, each slot the dragged icon moves across, and a drop that changed the strip. */
export function playPrimaryNavigationCustomizationFeedback(
  feedback: PrimaryNavigationCustomizationFeedback,
): void {
  if (Platform.OS === "web") {
    return;
  }
  const isAndroid = Platform.OS === "android";
  switch (feedback) {
    case "pickup": {
      ignoreFailure(
        isAndroid
          ? performAndroidHapticsAsync(AndroidHaptics.Drag_Start)
          : impactAsync(ImpactFeedbackStyle.Medium),
      );
      return;
    }
    case "hover": {
      ignoreFailure(
        isAndroid ? performAndroidHapticsAsync(AndroidHaptics.Segment_Tick) : selectionAsync(),
      );
      return;
    }
    case "drop": {
      ignoreFailure(
        isAndroid
          ? performAndroidHapticsAsync(AndroidHaptics.Gesture_End)
          : impactAsync(ImpactFeedbackStyle.Light),
      );
      return;
    }
  }
}
